function Page404() {
    return <h1>404 - Sorry, the page you are looking for could not be found</h1>
}
export default Page404;